export enum UserStatus {
  ACTIVE = 'ACTIVE',
  UNVERIFIED = 'UNVERIFIED',
}

export const USER_STATUS_CHOICES = [
  { id: UserStatus.ACTIVE, name: 'Active' },
  { id: UserStatus.UNVERIFIED, name: 'Unverified' },
]
